import { defineStore } from 'pinia'

export const useModalsStore = defineStore('modalsStore', {
  state: () => ({
    modalSuggestIdea: false,
    modalEmojiOpen: false,
    modalEmojiType: null,
    modalEmojiFieldId: null, // this is for such components like TextareaCustom or InputCustom
    modalAddListOfAnswersOpen: false,
    questionAddAnswersIndex: null,
    questionAddAnswersId: null,
    isOpenGetLinkMenuModal: false,
  }),
  getters: {
    isSuggestIdeaOpen(state) {
      return state.modalSuggestIdea;
    },
    isAddListOfAnswersOpen(state) {
      return state.modalAddListOfAnswersOpen;
    },
    isEmojiOpen(state) {
      return state.modalEmojiOpen;
    },
    isCreateEmojiOpen(state) {
      return state.modalEmojiOpen && state.modalEmojiType === 'create';
    },
    isEditEmojiOpen(state) {
      return state.modalEmojiOpen && state.modalEmojiType === 'edit';
    },
    isWorkboardHeaderEmojiOpen(state) {
      return state.modalEmojiOpen && state.modalEmojiType === 'workboard_header';
    },
  },
  actions: {
    toggleSuggestIdea() {
      this.modalSuggestIdea = !this.modalSuggestIdea;
    },
    openSuggestIdea() {
      this.modalSuggestIdea = true;
    },
    closeSuggestIdea() {
      this.modalSuggestIdea = false;
    },
    openAddListOfAnswers() {
      this.modalAddListOfAnswersOpen = true;
    },
    closeAddListOfAnswers() {
      this.modalAddListOfAnswersOpen = false;
    },
    openEmoji(type) {
      this.modalEmojiType = type;
      this.modalEmojiOpen = true;
    },
    closeEmoji() {
      this.modalEmojiOpen = false;
      this.modalEmojiType = null;
    },
    toggleEmoji(type) {
      if (this.modalEmojiOpen && this.modalEmojiType === type) {
        this.closeEmoji();
      } else {
        this.openEmoji(type);
      }
    },
    setEmojiFieldId(id) {
      this.modalEmojiFieldId = id;
    },
    clearEmojiFieldId() {
      this.modalEmojiFieldId = null;
    },
    isEmojiFieldIdOpenedBy(id) {
      return this.modalEmojiFieldId === id;
    },
    openGetLinkMenuModal() {
      this.isOpenGetLinkMenuModal = true;
     },
    closeGetLinkMenuModal() {
      this.isOpenGetLinkMenuModal = false;
    },
    toggleGetLinkMenuModal() {
      this.isOpenGetLinkMenuModal = !this.isOpenGetLinkMenuModal;
    },
  },
})
